const state = {
    successFactors: []
};

const mutations = {
    setSuccessFactors(state, value) {
        state.successFactors = value;
    },
};

const actions = {};

const getters = {
    successFactors: (state) => state.successFactors,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
